// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"ebb073b8","830":"e787bb75"}[chunkId] + ".js";
};